<template>
  <HeraFormSwitch
    v-model="registrationType"
    :label="$$t('Tournament privacy:', 'tournmament-privacy-label')"
    name="registration-type"
    :disabled="isTournamentFieldDisabled('registration_type')"
    :true-label="$$t('Public', 'options-open')"
    :false-label="$$t('Invitation', 'options-closed')"
    true-value="open"
    false-value="closed"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import HeraFormSwitch from '@/components/atoms/form/HeraFormSwitch';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentRegistrationTypeSetting',
  components: {
    HeraFormSwitch,
  },
  mixins: [translate('_web_tournament_additional_settings')],
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    registrationType: {
      get() {
        return this.$lodash.get(
          this.currentTournament,
          'info.registration_type',
          'open'
        );
      },
      set(newVal) {
        this.updateCurrentTournament({
          registration_type: newVal,
          component: 'info',
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>
